import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rankClass',
  standalone: true
})
export class RankClassPipe implements PipeTransform {
  transform(rank: number | null | undefined): string {
    if (rank === 1) return 'job-rank-first';
    if (rank === 2) return 'job-rank-second';
    if (rank === 3) return 'job-rank-third';
    return '';
  }
}
